import { render } from "./ModalDocumentSearch.vue?vue&type=template&id=5fcef20f"
import script from "./ModalDocumentSearch.vue?vue&type=script&lang=ts"
export * from "./ModalDocumentSearch.vue?vue&type=script&lang=ts"

import "./ModalDocumentSearch.vue?vue&type=style&index=0&id=5fcef20f&lang=scss"
script.render = render

export default script